import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { FirebaseAuthContext } from 'libs.firebase_react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export const useCloneCheckApi = (sourceAssetId, targetAssetId) => {
    const { get } = useApiClient(ApiClientService.WEB);
    const { firebaseToken } = useContext(FirebaseAuthContext);
    return useQuery({
        queryKey: ['import_from_asset_eligibility', sourceAssetId, targetAssetId],
        queryFn: () => {
            return get(`/api/v2/translation/import_from_asset_eligibility?sourceAssetId=${sourceAssetId}&targetAssetId=${targetAssetId}`, {
                withCredentials: false,
                headers: {
                    Authorization: `Bearer ${firebaseToken}`,
                },
            });
        },
        retry: false,
        enabled: !!sourceAssetId && !!targetAssetId && !!firebaseToken,
    });
};
